module.exports = __webpack_public_path__ + "../front/img/768_hylder+bøjestang.74563ff0.svg";